module.exports = __webpack_public_path__ + "img/logo.62ec106e.svg";